

"use strict";

/* ---------- Ajaxinate Core ---------- */
var Ajaxinate = function(config){
  var settings = config || {},
      defaultSettings = {
        pagination: ".AjaxinatePagination",
        method: "scroll",
        container: ".AjaxinateLoop",
        offset: 0,
        loadingText: '<div class="loading"></div>',
        callback: null
      };
  this.settings = Object.assign(defaultSettings, settings);

  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);
  this.initialize();
};

Ajaxinate.prototype.initialize = function(){
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  if (!this.containerElement) return;
  var initializers = { click: this.addClickListener, scroll: this.addScrollListeners };
  initializers[this.settings.method]();
};

Ajaxinate.prototype.addScrollListeners = function(){
  if (!this.paginationElement) return;

  // Scroll fallback
  document.addEventListener("scroll", this.checkIfPaginationInView);
  window.addEventListener("resize", this.checkIfPaginationInView);
  window.addEventListener("orientationchange", this.checkIfPaginationInView);

  // --- Intersection Observer addition ---
  if (window.IntersectionObserver) {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.nextPageLinkElement = this.paginationElement.querySelector("a");
          if (this.nextPageLinkElement) {
            this.nextPageLinkElement.innerHTML = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;
            this.loadMore();
          }
        }
      });
    }, { rootMargin: "200px 0px" }); // preload before user fully sees it

    this.observer.observe(this.paginationElement);
  }
};

Ajaxinate.prototype.addClickListener = function(){
  if (!this.paginationElement) return;
  this.nextPageLinkElement = this.paginationElement.querySelector("a");
  this.clickActive = true;
  if (this.nextPageLinkElement)
    this.nextPageLinkElement.addEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.stopMultipleClicks = function(event){
  event.preventDefault();
  if (this.clickActive && this.nextPageLinkElement){
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function(){
  if (!this.paginationElement) return;
  var rect = this.paginationElement.getBoundingClientRect();
  var top = rect.top - this.settings.offset;
  var bottom = rect.bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0){
    this.nextPageLinkElement = this.paginationElement.querySelector("a");
    this.removeScrollListener();
    if (this.nextPageLinkElement){
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function(){
  if (!this.nextPageUrl) return;

  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function(){
    if (this.request.readyState === 4 && this.request.status === 200){
      var doc = this.request.responseXML;
      var newContainer = doc.querySelector(this.settings.container);
      var newPagination = doc.querySelector(this.settings.pagination);

      if (newContainer && this.containerElement) {
        this.containerElement.insertAdjacentHTML("beforeend", newContainer.innerHTML);
      }

      if (newPagination && this.paginationElement) {
        this.paginationElement.innerHTML = newPagination.innerHTML;
      } else if (this.paginationElement) {
        this.paginationElement.parentNode && this.paginationElement.parentNode.removeChild(this.paginationElement);
        this.paginationElement = null;
      }

      if (typeof this.settings.callback === "function") {
        this.settings.callback(doc);
      }

      this.initialize();
    }
  }.bind(this);

  this.request.open("GET", this.nextPageUrl);
  this.request.responseType = "document";
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function(){
  if (this.nextPageLinkElement)
    this.nextPageLinkElement.removeEventListener("click", this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function(){
  document.removeEventListener("scroll", this.checkIfPaginationInView);
  window.removeEventListener("resize", this.checkIfPaginationInView);
  window.removeEventListener("orientationchange", this.checkIfPaginationInView);
  if (this.observer) {
    this.observer.disconnect();
    this.observer = null;
  }
};

Ajaxinate.prototype.destroy = function(){
  this.removeClickListener();
  this.removeScrollListener();
  return this;
};

/* ---------- Safe reinit for filter/facet changes ---------- */
var endlessScroll = null;
var reinitTimer = null;
var observer = null;

function debounce(fn, wait) {
  return function() {
    clearTimeout(reinitTimer);
    var args = arguments;
    reinitTimer = setTimeout(function() {
      fn.apply(null, args);
    }, wait || 200);
  };
}

function initAjaxinate() {
  if (endlessScroll && typeof endlessScroll.destroy === "function") {
    try { endlessScroll.destroy(); } catch (e) {}
    endlessScroll = null;
  }

  var maxAttempts = 20;
  var attempt = 0;
  var interval = setInterval(function() {
    attempt++;
    var container = document.querySelector('#AjaxinateContainer');
    if (container) {
      clearInterval(interval);
      endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        callback: function(doc) {
          lazyLoadPictures?.();
        }
      });
    } else if (attempt >= maxAttempts) {
      clearInterval(interval);
    }
  }, 150);
}

function observeForFacetChanges() {
  if (observer) return;
  var target = document.body;
  if (!target) return;

  observer = new MutationObserver(debounce(function(mutations) {
    var shouldReinit = false;
    mutations.forEach(function(m) {
      m.addedNodes && m.addedNodes.forEach(function(node) {
        if (!(node instanceof Element)) return;
        if (node.matches && (node.matches('#product-grid') || node.matches('#AjaxinatePagination'))) {
          shouldReinit = true;
        }
        if (node.querySelector && (node.querySelector('#product-grid') || node.querySelector('#AjaxinatePagination'))) {
          shouldReinit = true;
        }
      });
    });
    if (shouldReinit) initAjaxinate();
  }, 250));

  observer.observe(target, { childList: true, subtree: true });
}

document.addEventListener("DOMContentLoaded", function() {
  initAjaxinate();
  observeForFacetChanges();
});

document.addEventListener("facet:update", function() {
  setTimeout(function() {
    initAjaxinate();
  }, 250);
});

